/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/components/Collection.js":
/*!**********************************************!*\
  !*** ./src/scripts/components/Collection.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"initCollection\": () => (/* binding */ initCollection)\n/* harmony export */ });\nconst dom = {\n  overlay_layer: 'data-overlay--layer',\n  search_input: 'data-search--input',\n  search_input_btn: 'data-search-input-btn'\n};\n\nconst hideGFSButton = () => {\n  const elements = document.querySelectorAll('.boost-pfs-filter-tree-mobile-button');\n  elements && elements.forEach(element => {\n    element.addEventListener('click', event => {\n      const attentive_overlay = document.getElementById('attentive_overlay');\n      attentive_overlay && attentive_overlay.classList.add('hidden');\n    });\n  });\n};\n\nconst showGFSButton = () => {\n  const elements = document.querySelectorAll('.boost-pfs-filter-close');\n  elements && elements.forEach(element => {\n    element.addEventListener('click', event => {\n      const attentive_overlay = document.getElementById('attentive_overlay');\n      attentive_overlay && attentive_overlay.classList.remove('hidden');\n    });\n  });\n};\n\nconst overlayToggle = () => {\n  const overlay = document.querySelector(`[${dom.overlay_layer}]`);\n  const search_element = document.querySelector(`[${dom.search_input}]`);\n  const body = document.body;\n  search_element && search_element.addEventListener('click', () => {\n    setTimeout(function () {\n      const element = document.querySelector('.boost-pfs-search-suggestion-open');\n\n      if (element) {\n        overlay && overlay.classList.add('active');\n        body.classList.add('overflow-hidden');\n      } else {\n        overlay && overlay.classList.remove('active');\n        body.classList.remove('overflow-hidden');\n      }\n    }, 100);\n  });\n  overlay && overlay.addEventListener('click', () => {\n    overlay && overlay.classList.remove('active');\n    body.classList.remove('overflow-hidden');\n  });\n};\n\nconst showSearchField = () => {\n  const elements = document.querySelectorAll(`[${dom.search_input_btn}]`);\n  elements & elements.forEach(element => {\n    element.addEventListener('click', () => {\n      const el = document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel');\n\n      if (el) {\n        el.style.display = \"block\";\n      }\n    });\n  });\n};\n\nconst initCollection = () => {\n  hideGFSButton();\n  showGFSButton();\n  overlayToggle();\n  showSearchField();\n};\n\n//# sourceURL=webpack://charleston-shoe-co-theme/./src/scripts/components/Collection.js?");

/***/ }),

/***/ "./src/scripts/templates/search.js":
/*!*****************************************!*\
  !*** ./src/scripts/templates/search.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _components_Collection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/Collection.js */ \"./src/scripts/components/Collection.js\");\n\ndocument.addEventListener('DOMContentLoaded', () => {\n  (0,_components_Collection_js__WEBPACK_IMPORTED_MODULE_0__.initCollection)();\n});\n\n//# sourceURL=webpack://charleston-shoe-co-theme/./src/scripts/templates/search.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/templates/search.js");
/******/ 	
/******/ })()
;